<template>
    <div>
        <el-row>
            <el-col :span="24">
                <Head>
                    <template v-slot:title>
                        <span style="margin-left:30%;margin-right:39px;" :class="{'title-link':true,'avtive':info=='1'}" @click="myInfo('1')">我的资料</span>
                        <span :class="{'title-link':true,'avtive':info=='2'}" @click="myInfo('2')">公司主页</span>
                    </template>
                </Head>
            </el-col>
        </el-row>
        <el-row>
            <el-col>
                <personalData v-if="info==1"></personalData>
                <company v-else @getStautsFn="myInfo"></company>
            </el-col>
        </el-row>


    </div>
</template>
<script>
import Head from '@/components/header/head.vue';
import personalData from '@/views/personal/personal_data.vue';
import company from '@/views/personal/company.vue';
export default {
    data(){
        return {
             info:'1',
        }
    },
    methods:{
        myInfo(flag){
            console.log('flag')
            console.log(flag)
            this.info = flag
        },
    },
    components:{
        Head,
        personalData,
        company
    }
}
</script>
<style lang="less" scoped>
        .title-link{ 
            font-size: 18px;
            font-weight: 400;
            color:#868EA7;
            line-height: 30px;
            cursor:pointer;
            padding:18px 0;
        }
        .title-link.avtive{
            border-bottom:solid #1A80FC 1px;
            color: #1A80FC;
        }
</style>